<script lang="ts">
  export type AlertItem = { level: 'info' | 'warn' | 'critical'; title: string; detail: string };

  let { alerts = [] }: { alerts?: AlertItem[] } = $props();
</script>

{#if alerts.length > 0}
  <div class="alerts">
    {#each alerts as a, i (i)}
      <div class="alert {a.level}" role="alert">
        <span class="alert-dot"></span>
        <div class="alert-body">
          <strong>{a.title}</strong>
          <span>{a.detail}</span>
        </div>
      </div>
    {/each}
  </div>
{/if}

<style>
  .alerts {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 0.85rem;
  }

  .alert {
    display: flex;
    align-items: flex-start;
    gap: 0.65rem;
    padding: 0.75rem 1rem;
    border-radius: var(--radius-xl);
    font-size: 0.85rem;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid var(--glass-border);
    box-shadow: var(--glass-shadow);
    transition: box-shadow 0.25s ease;
  }

  .alert:hover {
    box-shadow: var(--glass-shadow-lg);
  }

  .alert-dot {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 50%;
    margin-top: 0.35rem;
    flex-shrink: 0;
    box-shadow: 0 0 8px currentColor;
  }

  .alert-body {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
  }

  .alert strong {
    font-weight: 700;
    font-size: 0.85rem;
  }

  .alert span {
    color: var(--text-secondary);
    font-size: 0.8rem;
  }

  .alert.info {
    background: rgba(219,234,254,0.5);
    border-color: rgba(59,130,246,0.25);
  }
  .alert.info .alert-dot {
    background: #3b82f6;
    color: #3b82f6;
  }

  .alert.warn {
    background: rgba(254,243,199,0.5);
    border-color: rgba(245,158,11,0.25);
  }
  .alert.warn .alert-dot {
    background: #f59e0b;
    color: #f59e0b;
  }

  .alert.critical {
    background: rgba(254,226,226,0.5);
    border-color: rgba(239,68,68,0.3);
  }
  .alert.critical .alert-dot {
    background: #ef4444;
    color: #ef4444;
  }
  .alert.critical strong { color: #dc2626; }
</style>
